import { type ReactElement, createContext, useContext, useMemo } from 'react';

import { TLogLevels } from './LoggerContext';
import { Generic, ProductNames } from '../interfaces/interfaces';
import { Endpoint } from '../store/Actions';

/* ================================================ Local Types ================================================ */
type TConfigContextProvider = (props: { initialConfig: IConfigProps; children: ReactElement }) => ReactElement;

/* ================================================ Exported Types ================================================ */
export interface IConfigProps {
    appBasePath: string;
    appName: string;
    logLevel: TLogLevels | undefined;
    product: ProductNames.CAR | ProductNames.CHILD;
    endpoint: Generic<Endpoint>;
}

/* ================================================ Main Component ================================================ */
const ConfigContext = createContext<IConfigProps>({} as IConfigProps);

export const ConfigContextProvider: TConfigContextProvider = ({ initialConfig, children }) => {
    return (
        <ConfigContext.Provider value={useMemo(() => ({ ...initialConfig }), [initialConfig])}>
            {children}
        </ConfigContext.Provider>
    );
};

export const useConfigContext = () => useContext(ConfigContext);
